import React from 'react';
import { motion } from 'framer-motion';

const StatisticsSection: React.FC = () => {
  const stats = [
    {
      title: "Projects completed",
      number: "20+",
      description: "We've successfully completed 20+ top-tier projects."
    },
    {
      title: "Satisfied customers",
      number: "95%",
      description: "We ensure a 95% satisfaction level for our clients."
    },
    {
      title: "Hours saved per day",
      number: "3h",
      description: "Our solutions save our clients an average of 3 hours of work per day."
    },
    {
      title: "Cost saved per month",
      number: "80k",
      description: "Our solutions save our clients an average of $80,000 per month."
    }
  ];

  return (
    <section className="py-24 bg-black relative overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-2">
            Our <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">statistics</span>
          </h2>
        </motion.div>

        {/* Statistics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-gray-900/50 border border-gray-800 rounded-xl p-8 relative group hover:border-gray-700 transition-all duration-300"
            >
              {/* Stat Content */}
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-white leading-tight">
                  {stat.title}
                </h3>
                
                <div className="text-5xl font-bold text-white">
                  {stat.number}
                </div>
                
                <p className="text-gray-400 text-sm leading-relaxed">
                  {stat.description}
                </p>
              </div>

              {/* Subtle accent dot in bottom right */}
              <div className="absolute bottom-6 right-6">
                <div className="w-2 h-2 bg-blue-400 rounded-full opacity-60"></div>
              </div>

              {/* Hover effect overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-cyan-400/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </motion.div>
          ))}
        </div>

        {/* Subtle background elements */}
        <div className="absolute top-1/2 left-1/4 w-1 h-1 bg-blue-400/40 rounded-full animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/3 w-1 h-1 bg-cyan-400/30 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-blue-300/50 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>
    </section>
  );
};

export default StatisticsSection;